var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 7.08335C11.6666 4.78217 9.80109 2.91669 7.49992 2.91669C5.19874 2.91669 3.33325 4.78217 3.33325 7.08335C3.33325 9.38452 5.19874 11.25 7.49992 11.25C9.80109 11.25 11.6666 9.38452 11.6666 7.08335Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 17.0833C13.3334 13.8617 10.7217 11.25 7.50008 11.25C4.27842 11.25 1.66675 13.8617 1.66675 17.0833",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.3274C13.3333 10.3274 14.3333 10.8706 14.8333 11.6667C14.8333 11.6667 16.3333 8.54167 18.3333 7.5",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.faaec5d65648f67e330eaae882bf1832.svg";
export { ForwardRef as ReactComponent };